

import React, { useEffect, useState, useMemo } from "react";
import { Modal, Form } from "react-bootstrap";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomContainer from "../../components/Customsettingscontain";
import CustomCard from "../../components/Customsettingscard";
import CustomInput from "../../components/Custominput";
import CustomButton from "../../components/CustomButton";
import CustomTable from "../../components/CustomTable";
import CustomSwitch from "../../components/Customswitch";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";
import DeleteModal from '../../components/DeleteModal';
import { getDeeparFilters, addDeeparFilter, deleteDeeparFilter, getDeeparKey, saveDeeparKey } from "../../services/reactapis";



export default function DeepARSettings() {
    const adminToken = localStorage.getItem("adminToken");

    // ---------- settings ----------
    const [settings, setSettings] = useState({
        androidKey: "",
        iosKey: "",
        useDeeparCamera: true,
    });
    const [savingSettings, setSavingSettings] = useState(false);
    const [settingsMsg, setSettingsMsg] = useState("");

    // ---------- filters ----------
    const [filters, setFilters] = useState([]);
    const [loading, setLoading] = useState(true);

    // ---------- add modal ----------
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState("");
    const [image, setImage] = useState(null);
    const [file, setFile] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    // ---------- delete modal ----------
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    // ---------- pagination + search ----------
    const [searchTerm, setSearchTerm] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);

    // ---------- load ----------
    const loadFilters = async () => {
        try {
            setLoading(true);
            const res = await getDeeparFilters(adminToken);
            if (res.success) setFilters(res.data);
        } catch (e) {
            console.log("Load error:", e?.response?.data || e.message);
        } finally {
            setLoading(false);
        }
    };

    const loadSettings = async () => {
        try {
            const res = await getDeeparKey(adminToken);
            if (res.success) {
                setSettings({
                    androidKey: res.data.androidKey || "",
                    iosKey: res.data.iosKey || "",
                    useDeeparCamera: !!res.data.useDeeparCamera,
                });
            }
        } catch (e) {
            console.log("Settings load error:", e?.response?.data || e.message);
        }
    };

    useEffect(() => {
        loadFilters();
        loadSettings();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, entriesPerPage]);

    // ---------- settings save ----------
    const handleSaveSettings = async () => {
        try {
            setSavingSettings(true);
            const res = await saveDeeparKey(adminToken, settings);
            setSettingsMsg(res.success ? "Saved" : res.message || "Failed");
        } catch (e) {
            setSettingsMsg(e?.response?.data?.message || "Save failed");
        } finally {
            setSavingSettings(false);
            setTimeout(() => setSettingsMsg(""), 2500);
        }
    };

    // ---------- add ----------
    const handleAdd = () => {
        setTitle("");
        setImage(null);
        setFile(null);
        setError("");
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setTitle("");
        setImage(null);
        setFile(null);
        setError("");
    };

    const handleSubmit = async () => {
        if (!title.trim() || !image || !file) {
            setError("All fields are required");
            return;
        }
        const fd = new FormData();
        fd.append("title", title.trim());
        fd.append("image", image);
        fd.append("file", file);

        try {
            setSaving(true);
            setError("");
            const res = await addDeeparFilter(adminToken, fd);
            if (res.success) {
                closeModal();
                loadFilters();
            } else {
                setError(res.message || "Failed");
            }
        } catch (err) {
            setError(err?.response?.data?.message || "Upload error");
        } finally {
            setSaving(false);
        }
    };

    // ---------- delete ----------
    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const deleteFilter = async () => {
        try {
            await deleteDeeparFilter(adminToken, deleteId);
            setShowDeleteModal(false);
            setDeleteId(null);
            loadFilters();
        } catch (err) {
            console.error(err);
        }
    };

    // ---------- search + pagination ----------
    const filteredFilters = filters.filter((item) =>
        (item.title || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.max(1, Math.ceil(filteredFilters.length / entriesPerPage));
    const startIndex = (currentPage - 1) * entriesPerPage;
    const paginatedFilters = filteredFilters.slice(startIndex, startIndex + entriesPerPage);

    const goToPage = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    return (
        <Layout>
            <SettingsPageShell wrapperClassName="rr-wrapper-live">
                <div className="ls-wrapper">
                    <div className="ls-section-title">DeepAR Settings</div>

                    <div className="ls-grid-3">
                        <CustomCard className="ls-card">
                            <CustomInput
                                label="DeepAR Android Key"
                                wrapperClassName=""
                                labelClassName="ls-label"
                                type="password"
                                className="ls-input"
                                value={settings.androidKey}
                                onChange={(e) => setSettings({ ...settings, androidKey: e.target.value })}
                            />
                        </CustomCard>

                        <CustomCard className="ls-card">
                            <CustomInput
                                label="DeepAR IOS Key"
                                wrapperClassName=""
                                labelClassName="ls-label"
                                type="password"
                                className="ls-input"
                                value={settings.iosKey}
                                onChange={(e) => setSettings({ ...settings, iosKey: e.target.value })}
                            />
                        </CustomCard>
                    </div>

                    <div style={{ margin: "12px 10px 20px", display: "flex", alignItems: "center", gap: 12 }}>
                        <button className="rr-add-btn" onClick={handleSaveSettings} disabled={savingSettings}>
                            {savingSettings ? "Saving..." : "Save"}
                        </button>
                        {!!settingsMsg && <span>{settingsMsg}</span>}
                    </div>

                    <div className="rr-card">
                        <div style={{ display: "flex", justifyContent: "space-between", margin: 10 }}>
                            <div className="ls-section-title">DeepAR Filters</div>
                            <button className="rr-add-btn" onClick={handleAdd}>
                                Add Filter
                            </button>
                        </div>

                        {loading ? (
                            <p style={{ margin: 10 }}>Loading...</p>
                        ) : (
                            <>
                                <div className="rr-controls rr-controls-spaced">
                                    <div className="rr-left">
                                        Show
                                        <select
                                            className="rr-select"
                                            value={entriesPerPage}
                                            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                                        >
                                            <option value={3}>3</option>
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                        </select>
                                        entries
                                    </div>

                                    <div className="rr-right">
                                        <span>Search:</span>
                                        <input
                                            className="rr-search"
                                            type="text"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <CustomTable className="rr-table" striped={"false"}>
                                    <tr>
                                        <th>Image</th>
                                        <th>Title</th>
                                        <th>File</th>
                                        <th className="rr-actions">Action</th>
                                    </tr>

                                    {paginatedFilters.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <img
                                                    src={item.image}
                                                    alt={item.title}
                                                    style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8 }}
                                                />
                                            </td>
                                            <td>{item.title}</td>
                                            <td>
                                                <a href={item.file} target="_blank" rel="noreferrer">
                                                    Filter File
                                                </a>
                                            </td>
                                            <td className="rr-actions">
                                                <CustomButton
                                                    className="rr-icon-btn red"
                                                    onClick={() => handleDeleteClick(item.id)}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </CustomButton>
                                            </td>
                                        </tr>
                                    ))}

                                    {paginatedFilters.length === 0 && (
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center" }}>
                                                No filters found
                                            </td>
                                        </tr>
                                    )}
                                </CustomTable>

                                <div className="rr-footer">
                                    <span>
                                        Showing {filteredFilters.length === 0 ? 0 : startIndex + 1} to{" "}
                                        {Math.min(startIndex + entriesPerPage, filteredFilters.length)} of{" "}
                                        {filteredFilters.length} entries
                                    </span>
                                    <div className="rr-pagination">
                                        <span
                                            className="rr-page-arrow"
                                            onClick={() => goToPage(currentPage - 1)}
                                            style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.5 : 1 }}
                                        >
                                            &lt;
                                        </span>
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                            <span
                                                key={page}
                                                className={`rr-page ${page === currentPage ? "active" : ""}`}
                                                onClick={() => goToPage(page)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {page}
                                            </span>
                                        ))}
                                        <span
                                            className="rr-page-arrow"
                                            onClick={() => goToPage(currentPage + 1)}
                                            style={{ cursor: currentPage === totalPages ? "not-allowed" : "pointer", opacity: currentPage === totalPages ? 0.5 : 1 }}
                                        >
                                            &gt;
                                        </span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </SettingsPageShell>

            {/* Add Filter modal */}
            <Modal show={showModal} onHide={closeModal} centered className="hashtag-add-modal">
                <Modal.Header className="hashtag-modal-header">
                    <Modal.Title>Add Filter</Modal.Title>
                    <CustomButton type="button" className="hashtag-close-btn" onClick={closeModal}>
                        ×
                    </CustomButton>
                </Modal.Header>

                <Modal.Body className="hashtag-modal-body">
                    <Form.Group className="mb-3">
                        <Form.Label className="profile-pill">Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            placeholder="Enter filter title"
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="profile-pill">Thumbnail Image (png / jpg)</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => setImage(e.target.files[0] || null)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="profile-pill">Filter File (.deepar)</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".deepar"
                            onChange={(e) => setFile(e.target.files[0] || null)}
                        />
                    </Form.Group>

                    {!!error && <p style={{ color: "#d33", margin: 0 }}>{error}</p>}
                </Modal.Body>

                <Modal.Footer className="hashtag-modal-footer">
                    <CustomButton className="hashtag-close-footer-btn" variant="secondary" onClick={closeModal}>
                        Cancel
                    </CustomButton>
                    <CustomButton variant="primary" className="hashtag-save-btn" onClick={handleSubmit} disabled={saving}>
                        {saving ? "Uploading..." : "Submit"}
                    </CustomButton>
                </Modal.Footer>
            </Modal>

            <DeleteModal
                show={showDeleteModal}
                close={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                }}
                onDelete={deleteFilter}
                title="Delete Filter"
                message="Are you sure you want to delete this filter?"
            />
        </Layout>
    );
}
